import React from "react";

const Backdrop = ({ onClick }) => (
  <div
    className="fixed inset-0 bg-black/30 z-[110]"
    onClick={onClick}
    aria-hidden
  />
);

const ConfirmTransactionDoneModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  errorText = null,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <Backdrop onClick={onClose} />
      <div className="fixed mt-[10px] mb-[10px] inset-0 z-[110] flex items-center justify-center">
        <div className="relative bg-white rounded-[12px] p-5 md:p-8 max-w-[625px] w-full mx-4">
          {/* Header */}
          <h3 className="text-page-title md:text-page-title-d font-rubik font-semibold text-[#1E1E1E] mb-4">
            Are you sure that you want to confirm transaction?
          </h3>

          {/* Content */}
          <div className="mb-8">
            <p className="text-[18px] font-[400] opacity-50 text-[#1E1E1E]">
              This action cannot be undone.
            </p>
          </div>

          {errorText && (
            <div className="mb-6 rounded-[8px] border border-red-200 bg-red-50 px-4 py-3">
              <p className="text-sm text-red-700">{errorText}</p>
            </div>
          )}

          {/* Actions */}
          <div className="flex flex-col md:flex-row gap-4 justify-end">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-3 text-esblue rounded-[8px] bg-white border border-[#DCEDFF] disabled:opacity-50 disabled:cursor-not-allowed font-[600] text-[14px]"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="px-4 py-3 bg-[#B9FFCC] text-[#16653F] rounded-[8px] disabled:opacity-50 disabled:cursor-not-allowed font-[600] text-[14px]"
            >
              {isLoading ? "Confirming..." : "Confirm transaction done"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmTransactionDoneModal;
